<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6116 22C14.3043 22 14.0047 21.8518 13.8408 21.5873L8.11905 12.4116C7.96032 12.1565 7.96032 11.8437 8.11905 11.5885L13.8383 2.41167C14.0834 2.01892 14.6243 1.88251 15.0522 2.11064C15.4776 2.33759 15.6237 2.84206 15.3786 3.23599L9.91584 12.0001L15.3811 20.7653C15.6262 21.158 15.4802 21.6625 15.0548 21.8895C14.9151 21.9647 14.7615 22 14.6116 22Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  name: "IconChevronLeft",
  data: () => ({
    iconColor: "currentColor",
  }),
};
</script>
